const commonActionTypes = {
  SET_CONTEXT: 'SET_CONTEXT',

  FETCH_STATIC_DATA: 'FETCH_STATIC_DATA',
  FETCH_STATIC_DATA_SUCCESS: 'FETCH_STATIC_DATA_SUCCESS',
  FETCH_STATIC_DATA_FAIL: 'FETCH_STATIC_DATA_FAIL',

  FETCH_SEARCH_PRODUCTS: 'FETCH_SEARCH_PRODUCTS',
  FETCH_SEARCH_PRODUCTS_SUCCESS: 'FETCH_SEARCH_PRODUCTS_SUCCESS',
  FETCH_SEARCH_PRODUCTS_FAIL: 'FETCH_SEARCH_PRODUCTS_FAIL',
  RESET_SEARCH_PRODUCTS: 'RESET_SEARCH_PRODUCTS',
};

export default commonActionTypes;
